import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=dd85273c&scoped=true&"
import script from "./breadcrumb.vue?vue&type=script&lang=js&"
export * from "./breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=dd85273c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd85273c",
  null
  
)

export default component.exports